"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuppressionReferenceIds = getSuppressionReferenceIds;
function matchesReferenceKey(filter, keys) {
  const filterKeys = filter.key?.equals ? [filter.key.equals] : filter.key?.in?.values || [];
  return keys.some(key => filterKeys.includes(key));
}
function getSuppressionReferenceIds(keyFilter, keys) {
  return [...new Set((keyFilter?.filters || []).flatMap(filter => {
    if (filter.value?.not || !matchesReferenceKey(filter, keys)) {
      return [];
    }
    return filter.value?.equals !== undefined ? [filter.value.equals] : filter.value?.in?.values || [];
  }))];
}